<ion-item detail-push (click)="studentClicked($event)">
  <span class="studentName">{{ student.forename }}</span>

  @if (showAttendance && student.lastSession) {
    <div class="attendanceCont">
      <span [ngClass]="student.lastSession !== null ? student.lastSession.am.class : 'none'"></span>
      <span [ngClass]="student.lastSession !== null ? student.lastSession.pm.class : 'none'"></span>
    </div>
  }
</ion-item>
